namespace JupitersChoice {
    export class HideSpinnerCmd {

        @inject('LayerManager') _layerManager: Sapphire.LayerManager;

        execute(): void {
            this._layerManager.setVisibility('Spinner', false);
        }
    }
}